
<script>
import { defineComponent, computed, onBeforeUnmount, inject } from 'vue'
import { pathname, cmsasset } from '@kit/utils/Formats'
import { useStore } from 'vuex'
import { slugPageSetup } from '@kit/utils/Setup' 
import '@css/index.css'
import Column from '@kit/components/Column.vue'
import Shine from '@kit/components/Shine.vue'
import Icon from '@kit/components/Icon.vue'
import LazyImg from '@kit/components/LazyImg.vue'
import Img from '@kit/components/Img.vue'
import { xLazyTheme } from '@project/themes'


export default defineComponent({
  name: "Flower",

  setup() {

    const store = useStore()
    const themer = inject("themer")
    const xLazyTheme_ = themer(xLazyTheme)

    const inMobile = computed(() => {
      return store.state.inMobile
    })
    
    const { id, prefetch } = slugPageSetup({
      routeParam: 'slug',
      prefetchKey: 'flower',
      prefetchExtra: ['home'],
      metadata(flower, meta) {

        const seo = flower.seo_set ? flower.seo_set[0] : null

        if(seo) {

          meta.addCanonical()
          meta.addTitle('Sunrise Protea | '+seo.page_title)
          meta.addMetaItem([
            { name:'description', content: seo.page_description },
            { name:'og:title', content: seo.open_graph_title },
            { name:'og:description', content: seo.open_graph_description }
          ])

          if(seo.open_graph_image) {
            meta.addMetaItem([
              { name:"og:image", content: cmsasset(seo.open_graph_image.guid) },
              { name:"og:image:alt", content: seo.open_graph_image_alt },
            ])
          }

        }

      }

    })


    return { 
      id,
      cmsasset,
      pathname, 
      prefetch, 
      inMobile,
      xLazyTheme_,
    }
  },


  components: {
    Column,
    Shine,
    Icon,
    LazyImg,
    Img
  },
});
</script>

<style scoped>

/* .main-flower-image {
  width:80% !important;
  height:400px !important;
}
@media (max-width:600px) {
  .main-flower-image {
    width:100% !important;
    height:200px !important;
  }  
}
@media (min-width:1400px) {
  .main-flower-image {
    width:60% !important;
    height:400px !important;
  }  
} */

.tile {
  width:50% !important;
}
@media (max-width:900px) {
  .tile  {
    width:100% !important;
  }  
}

.breadcrumb-icon {
  fill:var(--link);
  width:20px !important;
}
.breadcrumb-icon > svg {
  fill:var(--link);
}
.breadcrumb-text {
  line-height:var(--h3LH);
  font-size:var(--h3);
  white-space: nowrap;
}

@media (max-width:900px) {
  .breadcrumb-icon {
    width:15px !important;   
  }
}

.additional-flower-square {
  padding-top:70% !important;
  width:100% !important;
}
/* @media (max-width:900px) {
  .additional-flower-square {
    height:180px !important;
  } 
}
@media (max-width:600px) {
  .additional-flower-square {
    height:140px !important;
  } 
} */

</style>


<template>
 
  <main class="sb sb-v sb-greedy page-margin-top" role="main">

    <Column v-if="prefetch && prefetch.flower" ltD="60" gtB="700" gtD="700" gtH="700" tag="article" class="sb-v sb-g20" style="margin-bottom:30px;">
      
      <h1 class="sb sb-text">{{ prefetch.flower.display_title }}</h1>

      <div class="sb sb-h sb-gr sb-g10 sb-alt2 sb-align-cv" style="padding:0px;">
        <router-link class="sb sb-text breadcrumb-text" :to="`/family/${prefetch.flower.family[0].url_slug}`">{{ prefetch.flower.family[0].display_title }}</router-link> 
        
        <div class="sb sb-explicit sb-text breadcrumb-icon">
          <Icon icon="rounded-single-chevron-right"/>  
        </div>

        <h3 class="sb sb-text breadcrumb-text">{{ prefetch.flower.display_title }}</h3>
      </div>

      <div class="sb sb-h sb-gr sb-g10" style="padding:0px;">
        <h3 class="sb">Belongs to: </h3><router-link 
          v-for="v, i in prefetch.flower.variety" 
          :to="`/variety/${v.url_slug}`"
          class="sb sb-text breadcrumb-text">{{ v.display_title }}{{ i < prefetch.flower.variety.length-1 ? ',' : '' }}</router-link>
      </div>

      <div class="sb sb-text banner" v-if="prefetch && prefetch.home && prefetch.flower && prefetch.flower.available">This plant is available: {{ prefetch.home.availability_window }}</div>

      <div v-if="prefetch.flower.flower_image" class="sb">
        <Img class="sb sb-explicit" :src="cmsasset(prefetch.flower.flower_image[0].image.guid, 1536)" :theme="xLazyTheme_"/>
      </div> 


      <h2 v-if="prefetch.flower.additional_flower_images.length > 0" class="sb sb-text">Pictures of {{ prefetch.flower.display_title }}</h2>

      <ul v-if="prefetch.flower.additional_flower_images.length > 0" class="sb sb-h sb-gr" style="flex-wrap:wrap;">

        <li class="sb sb-explicit sb-v sb-align-cv sb-gr" style="width:50%; padding:10px;" v-for="flower in prefetch.flower.additional_flower_images">
          <Img :background="true" class="sb additional-flower-square" :src="cmsasset(flower.image.guid, 864)" :theme="xLazyTheme_" :ariaLabel="flower.aria_label"/>
        </li>

      </ul>

      <h3 class="sb sb-text">About {{ prefetch.flower.display_title }}</h3>

      <p class="sb sb-text" v-html="prefetch.flower.main_text"></p>

    </Column>
    <Column v-else ltD="60" gtB="700" gtH="700" tag="article" class="sb-v sb-g30" style="margin-bottom:30px;">
      <Shine min="100px" h="100px" shine="light" />
      <Shine min="100px" h="100px" shine="light" />
      <Shine min="100px" h="100px" shine="light" />
    </Column>


  </main>

</template>
